import React from 'react';

const NotFoundFolderIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="61" viewBox="0 0 60 61" fill="none">
      <mask id="mask0_3831_23344" maskUnits="userSpaceOnUse" x="0" y="0" width="60" height="61">
        <rect y="0.5" width="60" height="60" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3831_23344)">
        <path
          d="M10.7093 47.9285C9.85178 47.9285 9.11449 47.62 8.4974 47.0029C7.88032 46.3858 7.57178 45.6537 7.57178 44.8066V16.4829C7.57178 15.6354 7.92844 14.8552 8.64178 14.1423C9.35469 13.4289 10.1399 13.0723 10.9974 13.0723H24.6174L29.0049 17.4598H49.013C49.681 17.4598 50.2837 17.636 50.8212 17.9885C51.3587 18.341 51.7499 18.7937 51.9949 19.3466H28.2112L23.8243 14.9598H10.9974C10.5487 14.9598 10.1801 15.1039 9.89178 15.3923C9.60344 15.6806 9.45928 16.0491 9.45928 16.4979V44.4454C9.45928 44.7979 9.5474 45.0862 9.72365 45.3104C9.8999 45.535 10.1322 45.7273 10.4205 45.8873L16.2524 24.6954H57.1418L51.3987 45.5966C51.1441 46.3833 50.742 46.9685 50.1924 47.3523C49.6424 47.7364 48.9655 47.9285 48.1618 47.9285H10.7093ZM12.3774 46.041H49.3174L54.5818 26.5823H17.6418L12.3774 46.041Z"
          fill="#969696"
        />
      </g>
    </svg>
  );
};

export default NotFoundFolderIcon;
